import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-video\"><path d=\"M26 4a4.013 4.013 0 0 1 3.995 3.801L30 8v16a4.013 4.013 0 0 1-3.801 3.995L26 28H6a4.013 4.013 0 0 1-3.995-3.801L2 24V8a4.013 4.013 0 0 1 3.801-3.995L6 4zm0 2H6a2 2 0 0 0-1.995 1.85L4 8v16a2 2 0 0 0 1.85 1.995L6 26h20a2 2 0 0 0 1.995-1.85L28 24V8a2 2 0 0 0-2-2m-14 4.917 10 5.416-10 5.417z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol